import { format, parseISO } from 'date-fns'
import React from 'react'
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'

import BlankSlate from '../../../../../components/BlankSlate'
import dashboardWhite from '../../../../../icones/iconesVersaoClara/dashboard.svg'
import dashboardDark from '../../../../../icones/iconesVersaoEscura/dashboard.svg'
import { formatDateToLabel } from '../../../../../utils/genericFormatters'

import * as S from './styles'

const CustomTooltip = ({ payload, active }) => {
  if (active && payload && payload.length) {
    const formattedData = format(
      parseISO(payload[0].payload.data),
      'dd/MM/yyyy'
    )

    const hora = payload[0]?.payload?.hora
    const consumo = payload[0]?.payload?.consumo

    const concatData = hora ? `${formattedData} - ${hora}` : formattedData

    return (
      <S.TooltipWrapper>
        <S.TooltipContent>
          <S.TituloTooltip> {concatData}</S.TituloTooltip>
          <S.TextTooltip>
            Consumo: {parseFloat(`${consumo || '00'}`).toFixed(2)} MB
          </S.TextTooltip>
        </S.TooltipContent>
      </S.TooltipWrapper>
    )
  }

  return null
}

export default function Grafico({ data }) {
  const localTheme = localStorage.getItem('tema')
  const gridColor = '#656565'
  const barColor = localTheme === 'claro' ? '#ECF0EE' : '#2b2b2b'
  const filledBarColor = '#36D896'

  const theme = localTheme || 'claro'
  const isDarkTheme = theme === 'escuro'

  const corTema = () => {
    if (isDarkTheme) return dashboardDark
    else return dashboardWhite
  }

  if (!data || !data.length) {
    return (
      <S.BlankSlateContainer>
        <BlankSlate
          size="md"
          icon={corTema()}
          title="Sem consumo registrado."
          subTitle="Nenhum registro de consumo foi encontrado neste intervalo, ajuste o filtro de datas para ver registros anteriores."
        />
      </S.BlankSlateContainer>
    )
  }

  return (
    <S.Container>
      <ResponsiveContainer>
        <BarChart
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <CartesianGrid stroke={gridColor} strokeDasharray="0" />
          <XAxis
            stroke={gridColor}
            dataKey="data"
            tickFormatter={(date) => formatDateToLabel(date)}
          />
          <YAxis stroke={gridColor} dataKey="consumo" />
          <Tooltip
            cursor={{ fill: 'transparent' }}
            content={<CustomTooltip />}
          />
          <Bar
            barSize={68}
            dataKey="consumo"
            fill="#36D896"
            background={{
              fill: barColor
            }}
            radius={(5, 0, 0, 5)}
          >
            {data?.map((index) => (
              <Cell key={`cell-${index}`} fill={filledBarColor} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </S.Container>
  )
}
